/* InputFileControlComponent.js */

"use strict";

const InputBaseControlTextfieldComponent = require("@gluenetworks/input_base_control").Textfield;
const Renderer = require("./InputFileControlRenderer");

class InputFileControlComponent extends InputBaseControlTextfieldComponent {
    /**
     * @schema.name Input File Control
     * @schema.package @gluenetworks/input_file_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Textfield.InputText
     * @schema.events ["Disabled", "Value", "Visible", "Invalid", "DarkTheme", "FileHandle", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._label = this._setControlParam(configOptions.label, "Import from File");
        this._accept = this._setControlParam(configOptions.acceptFiles, ".csv, .json");
        this._id = this._setControlParam(configOptions.id, "inputFile");
        this._multiple = this._setControlParam(configOptions.multiple, false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._multiple = undefined;
            this._disabled = undefined;
            this._invalid = undefined;
            this._visible = undefined;
            this._value = undefined;
            this._darkTheme = undefined;
            this._theme = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _setControlParam(param, defaultValue) {
        return param && param.length > 0 ? param : defaultValue;
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = InputFileControlComponent;
